import React, { useState, useEffect } from "react";
import Helpers from "../../helpers/shared.helper";
import Storage from "../../services/storage.service";
import Settings from "../../services/settings.service";
import Translations from '../../services/translation.service';
import BillPaymentService from "../../services/bill-payment.service";
import OtpScreen from "../shared/otp-screen/otpScreen";
import FirebaseAnalytics from "../../services/analytics.service";

const subscriptions = [];
const BillPaymentOTP = (props) => {
    const { history } = props;
    const [translationKeys, setTranslationsKeys] = useState(
        Translations.keys ? Translations.keys : {}
    );
    // Initialize state with default value
    const [formValues, setFormValues] = useState({});
    const [otpData, setOtpData] = useState({
        otpError: false,
        otpForm: {
            formValid: false,
            otp: {
                value: "",
                tuched: false,
                validation: false,
                rules: Settings.formats.otpCodeWithoutLength,
                required: true,
            },
        }}
    )
    const [OTPLength, setOTPLength] = useState(6);
    const [OTPTimer, setOTPTimer] = useState(30);
    const [loading, setLoading] = useState(false);
    const [maskedContactNumber, setMaskedContactNumber] = useState(null);
    
    useEffect(() => {
        setOTPLength(Helpers.getOTPLength("otp_bill_payment_length"));
        setOTPTimer(Helpers.getOTPTimer("resend_otp_timer"));
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        // Check if state exists in history.location and set the data accordingly
        if (history?.location?.state && history?.location?.state?.formValues) {
            setFormValues(history?.location?.state?.formValues);
            if(history?.location?.state?.formValues?.maskedContactNumber) {
                setMaskedContactNumber(history?.location?.state?.formValues?.maskedContactNumber);
            }
        }
    }, [history.location.state]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        const firebase_event_params = {
            event_category: 'bills',
            event_screen: 'bill_otp',
            interaction_type: 'view',
            event_label: 'otp'
        }
        FirebaseAnalytics.commonFunction(firebase_event_params);

        subscriptions.push(
        Translations.getKeysObsrv().subscribe((data) => {
            setTranslationsKeys(data);
        })
        );

        return () => {
        if (subscriptions && subscriptions?.length) {
            for (let subscription of subscriptions) {
            subscription.unsubscribe();
            }
        }
        };
    }, []);

    const requestNewOtp = () => {
        setLoading(true);
        let countryCode = Helpers.getCountryCodePO() || "";
        let data = {
            number: formValues?.phone?.value.length === 15 ? formValues?.phone?.value : `${countryCode}${formValues?.phone?.value?.replace(/^0+/, '')}`,
            process: "bill_payment"
        }
        BillPaymentService.requestOTP(data)
        .then(response => {
            if(response) {
                setLoading(false);
            }
        })
        .catch(error => {
            setLoading(true);
        });
    }

    const otpFormSubmit = () => {
        setLoading(true);
        Storage.clear("genericOTPError");
        Storage.set("genericOTPError", true, true);
        let countryCode = Helpers.getCountryCodePO() || "";
        let data = {
            number: formValues?.phone?.value.length === 15 ? formValues?.phone?.value : `${countryCode}${formValues?.phone?.value?.replace(/^0+/, '')}`,
            otp: otpData?.otpForm?.otp?.value
        }
        BillPaymentService.verifyOTP(data)
        .then((res) => {
            if (res) {
                props.history.push({
                    pathname: '/bill-payment/bills',
                    state: { formValues: formValues }
                });
                setLoading(false);
            } else {
                setOtpData((prevState) => ({
                    ...prevState,
                    otpError: true
                }));
                setLoading(true);
            }
            const firebase_event_params = {
                event_category: 'bills',
                event_screen: 'bill_otp',
                interaction_type: 'click',
                event_label: 'next',
                otp_is_valid: otpData?.otpForm?.formValid ?? ""
            }
            FirebaseAnalytics.commonFunction(firebase_event_params);
            Storage.clear("genericOTPError");
        })
        .catch((err) => {
            Storage.clear("genericOTPError");
            setOtpData((prevState) => ({
                ...prevState,
                otpError: true
            }));
            const firebase_event_params = {
                event_category: 'bills',
                event_screen: 'bill_otp',
                interaction_type: 'click',
                event_label: 'error',
                error_code: err?.response?.data?.code || ""
            }
            FirebaseAnalytics.commonFunction(firebase_event_params);
            setLoading(false);
        });
    }

    const handleOtpForm = (value) => {
        const updatedState = { ...otpData };
        if (value.length === OTPLength) {
          updatedState.otpForm.formValid = true;
        } else {
          updatedState.otpForm.formValid = false;
          updatedState.otpError = false;
        }
        updatedState.otpForm.otp.value = value;
        setOtpData((prevState) => ({
            ...prevState,
            ...updatedState
        }));
    };

    const handleOtpError = (value) => {
        setOtpData((prevState) => ({
            ...prevState,
            otpError: value,
        }));
    }

    return (
    <OtpScreen
        onSubmit={otpFormSubmit}
        isFormValid={otpData.otpForm.formValid}
        requestNewOtp={requestNewOtp}
        otpError={otpData.otpError}
        handleOtpForm={handleOtpForm}
        handleOtpError={handleOtpError}
        title={translationKeys["stm_bill_payment_otp_verify"]}
        desc={maskedContactNumber ? 
            `${translationKeys["stm_bill_payment_otp_desc1_hbb"] + " "}${OTPLength || 6}${" " + translationKeys["stm_bill_payment_otp_desc2_hbb"]}${" " + maskedContactNumber}${" " + translationKeys["stm_bill_payment_otp_desc3_hbb"]}` : 
            `${translationKeys["stm_bill_payment_otp_desc1"] + " "}${OTPLength || 6}${" " + translationKeys["stm_bill_payment_otp_desc2"]}`}
        otpLength={OTPLength}
        translationNeeded={false}
        loading={loading}
        timer={OTPTimer}
    />)
}
export default BillPaymentOTP;